/* unplugin-vue-components disabled */import { render } from "./prompts.vue?vue&type=template&id=0373e4d4"
import script from "./prompts.vue?vue&type=script&lang=js"
export * from "./prompts.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/chat-input-v2/prompts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0373e4d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0373e4d4', __exports__)) {
    api.reload('0373e4d4', __exports__)
  }
  
  module.hot.accept("./prompts.vue?vue&type=template&id=0373e4d4", () => {
    api.rerender('0373e4d4', render)
  })

}


export default __exports__